import { render, staticRenderFns } from "./Institution-comp.vue?vue&type=template&id=78eee6fa&"
import script from "./Institution-comp.vue?vue&type=script&lang=js&"
export * from "./Institution-comp.vue?vue&type=script&lang=js&"
import style0 from "./Institution-comp.vue?vue&type=style&index=0&id=78eee6fa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports